module.exports = __webpack_public_path__ + "static/media/MANOJ SIR A01.66d2b02e.jpg";